import React from 'react';
import { enums, formatUserName } from '~/util';
import { ActiveToggle } from '~/components/Admin';
import { moment, momentFormats } from '~/vendorConfigs/moment';

interface BasicInfoProps {
    user: UserType;
    setServerError: (e: { message: string }) => void;
    editable: boolean;
}
export function BasicInfo({ user, setServerError, editable }: BasicInfoProps) {
    return (
        <div>
            <div>{formatUserName(user, true)}</div>
            <div>{user.title}</div>
            <div>{user.email}</div>
            <div>Access Type: {enums(['user', 'access_type', user.access_type])}</div>
            <div>MSID: {user.msid || 'None'}</div>
            <div>
                <label htmlFor="user-activation">Status:</label>
                &nbsp;
                <span className={user.enabled_at ? 'text-success' : 'text-danger'}>
                    {user.enabled_at ? 'Active' : 'Disabled'}
                </span>
                {editable && (
                    <>
                        &nbsp; (<ActiveToggle user={user} setServerError={setServerError} />)
                    </>
                )}
            </div>
            <div>
                Last Enabled:{' '}
                {user.enabled_at ? moment(user.enabled_at).format(momentFormats.DATE) : 'N/A'}
            </div>
        </div>
    );
}
